var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"homeVideo"}},[_c('video',{attrs:{"poster":_vm.poster,"autoplay":"autoplay","muted":"muted","loop":"loop","preload":"auto","inline-video":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }